import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function Workshops() {
  const [filter, setFilter] = useState('All');
  const filters = ['All', 'Cooking', 'Cultural', 'Professional'];
  const workshops: {
    id: number;
    category: string[];
    date: string;
    time: string;
    title: string;
    instructor: string;
    blurb: string;
    price: string;
    note?: string;
    cta?: string;
    link?: string;
    image?: string;
  }[] = [{
    id: 7,
    category: ['Cooking', 'Cultural'],
    date: 'Tue October 15',
    time: '6–8 PM',
    title: 'Sancocho Colombian Soup',
    instructor: 'Chef Maritza Hurtado',
    blurb: "Chef Maritza of Pimiento Kitchen teaches sancocho, Colombia's soul-warming soup, the traditional way her mother Mama Gaby taught her. Build layers of flavor with hearty meats, plantains, yuca, corn and aromatic herbs, and hear stories from her home in Tura. No experience necessary. Just bring your appetite.",
    price: 'Free',
    image: 'https://cdn.magicpatterns.com/uploads/vVM5WDx8o7T5Bmyb5oJM57/Web_Flyer_(pimiento).png',
    link: 'https://www.eventbrite.com/e/2002480371697?aff=oddtdtcreator',
    cta: 'Register on Eventbrite'
  }, {
    id: 8,
    category: ['Cooking', 'Cultural'],
    date: 'Tue October 27',
    time: '6–8 PM',
    title: 'Mexican Hot Chocolate & Churros',
    instructor: 'Adrien Lopez Lanusse',
    blurb: 'As Día de los Muertos approaches, turn cacao into rich, frothy chocolate caliente and make crisp, tender churros. Adrien, a home chef and child of immigrants from Mexico and France, traces the food connections between Mexico, Spain and France.',
    price: 'Free',
    image: 'https://cdn.magicpatterns.com/uploads/6XdNbCxdNkHBgyxgUX9JTd/web_Flyer_(Lopez_Lanusse).png',
    link: 'https://www.eventbrite.com/e/2002480814020?aff=oddtdtcreator',
    cta: 'Register on Eventbrite'
  }, {
    id: 2,
    category: ['Professional'],
    date: 'Mon November 9',
    time: '9 AM – 3 PM',
    title: 'Food Protection Manager Certification',
    instructor: 'Certified Instructor',
    blurb: 'Earn your accredited Food Protection Manager Certification. This course covers safe food handling, storage, and preparation, and includes the certification exam — ideal for vendors, chefs, and food entrepreneurs.',
    price: 'Free',
    note: 'Limited availability',
    cta: 'Register on Eventbrite',
    link: 'https://www.eventbrite.com/e/food-protection-manager-certification-course-exam-tickets-1998019092892'
  }];
  const filteredWorkshops = filter === 'All' ? workshops : workshops.filter(w => w.category.includes(filter));
  return <section id="workshops" className="py-20 lg:py-32 bg-foodCard border-y-4 border-foodMaroon relative overflow-hidden" data-id="element-288" data-mp="6z7nirwjz5fv">
      {/* Decorative background element */}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-289" data-mp="228xakg0fimy">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-290" data-mp="2dnzv5pmzhjnv">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="max-w-2xl" data-id="element-291" data-mp="2im1embobnkzv">
            <h2 className="text-5xl md:text-6xl font-extrabold uppercase mb-4" data-id="element-292" data-mp="1uvf9ot9m6gu3">
              Workshops & <span className="text-foodOrange" data-id="element-293" data-mp="1zxo31qqefkwq">Classes</span>
            </h2>
            <p className="text-xl font-medium" data-id="element-294" data-mp="1kzvph44ex6l6">
              Roll up your sleeves. Every workshop is a free community
              experience — learn new skills, connect with neighbors, and eat
              what you make.
            </p>
          </motion.div>

          {/* Filters */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-wrap gap-2" data-id="element-295" data-mp="3kc6hxv61gm4r">
            {filters.map(f => <button key={f} onClick={() => setFilter(f)} className={`px-4 py-2 font-bold border-2 border-foodMaroon transition-all ${filter === f ? 'bg-foodMaroon text-foodCream shadow-[2px_2px_0px_0px_#F4631E]' : 'bg-foodCream text-foodMaroon hover:bg-foodGold hover:shadow-[2px_2px_0px_0px_#2A1B14]'}`} data-id="element-296" data-mp="1bb3c4jdljx9b">
                {f}
              </button>)}
          </motion.div>
        </div>

        {/* Grid */}
        <motion.div layout className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-297" data-mp="nl9209knwmsr">
          <AnimatePresence data-id="element-298" data-mp="ij09tffm5orp">
            {filteredWorkshops.map(workshop => <motion.div layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.3
          }} key={workshop.id} className="bg-foodCream border-4 border-foodMaroon p-6 flex flex-col h-full hover:-translate-y-2 hover:border-foodOrange hover:shadow-[8px_8px_0px_0px_#2A1B14] transition-all duration-300 group" data-id="element-299" data-mp="dm9s6no5ul46">
                {workshop.image && <div className="-mx-6 -mt-6 mb-6 border-b-4 border-foodMaroon bg-foodMaroon aspect-[4/3] overflow-hidden" data-id="element-300" data-mp="3qsax5jyof7vg">
                    <img src={workshop.image} alt={`${workshop.title} with ${workshop.instructor}`} className="w-full h-full object-cover" data-id="element-301" data-mp="2y5yiaaaevz2k" />
                  </div>}
                <div className="flex justify-between items-start mb-4" data-id="element-302" data-mp="2v20t8padrep8">
                  <div className="flex flex-col gap-1" data-id="element-303" data-mp="2q4942314e6oq">
                    <span className="bg-foodOrange text-white font-bold px-3 py-1 text-sm border-2 border-foodMaroon rotate-[-2deg] w-fit" data-id="element-304" data-mp="34tnelegfmu5p">
                      {workshop.date}
                    </span>
                    <span className="text-foodMaroon/60 font-bold text-xs uppercase tracking-wider pl-1" data-id="element-305" data-mp="2c4zq7a0dzonx">
                      {workshop.time}
                    </span>
                  </div>
                  <div className="flex flex-col items-end" data-id="element-306" data-mp="2m35oziqwceok">
                    <span className="font-display font-bold text-xl text-foodTomato uppercase" data-id="element-307" data-mp="2m4qj579atvlw">
                      {workshop.price}
                    </span>
                    {workshop.note && <span className="text-[11px] font-medium text-foodMaroon/60 italic mt-0.5" data-id="element-308" data-mp="1favum9agp10">
                        {workshop.note}
                      </span>}
                  </div>
                </div>

                <h3 className="text-2xl font-extrabold uppercase mb-2 group-hover:text-foodOrange transition-colors" data-id="element-309" data-mp="8wftxchkgmfr">
                  {workshop.title}
                </h3>
                <p className="text-foodMaroon/60 font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-310" data-mp="3r4oquk7jqefl">
                  with {workshop.instructor}
                </p>
                <p className="mb-8 flex-grow font-medium" data-id="element-311" data-mp="mpf4d02hrqgg">{workshop.blurb}</p>

                {workshop.link ? <a href={workshop.link} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-transparent border-4 border-foodMaroon text-foodMaroon font-bold py-3 hover:bg-foodMaroon hover:text-foodCream transition-colors mt-auto" data-id="element-312" data-mp="rmfbzfezp19o">
                    {workshop.cta || 'Reserve Free Spot'}
                  </a> : <p className="w-full text-center border-4 border-dashed border-foodMaroon/40 text-foodMaroon/70 font-bold py-3 mt-auto" data-id="element-313" data-mp="lnainyccfgjk">
                    RSVP link coming soon
                  </p>}
              </motion.div>)}
          </AnimatePresence>
        </motion.div>

        {filteredWorkshops.length === 0 && <div className="text-center py-20" data-id="element-314" data-mp="6wber0mgdg6b">
            <p className="text-2xl font-bold text-foodMaroon/50" data-id="element-315" data-mp="14kvb1febgx8x">
              No workshops found for this category.
            </p>
          </div>}
      </div>
    </section>;
}